import {CLOUD_BILLING_ENTITY_TYPE, CLOUD_BILLING_TYPE_REQUEST} from 'containers/cloud-billing/utils/constants';

import {invalidateCloudBillingSpending} from './store/cloudBillingSpending';
import {invalidateCloudBillingResume} from './store/cloudBillingResume';
import {invalidateCloudBillingEntities} from './store/cloudBillingEntities';

import {
    NEW_CLOUD_BILLING_ENTITIES_EXPLORER_UI_TAGS,
    NEW_CLOUD_BILLING_SUBENTITIES_EXPLORER_UI_TAGS,
    NEW_CLOUD_BILLING_ENTITIES_BREAKDOWN_UI_TAGS
} from 'modules/ui';


export const invalidateCloudBillingExplorer = () => dispatch => {
    dispatch(invalidateCloudBillingResume());
    dispatch(invalidateCloudBillingSpending());
    dispatch(invalidateCloudBillingEntities());

};

export const getUITags = (storage, isSubEntity) => {
    if (storage === 'breakdown') {
        return NEW_CLOUD_BILLING_ENTITIES_BREAKDOWN_UI_TAGS;
    } else if (isSubEntity) {
        return NEW_CLOUD_BILLING_SUBENTITIES_EXPLORER_UI_TAGS;
    }

    return NEW_CLOUD_BILLING_ENTITIES_EXPLORER_UI_TAGS;
};

export const getFetchParams = props => {
    const
        {selectedMonth, entityType, sort, filters, pagination, isSubEntity, subEntityType, selectedEntities, requestType, showSelection} = props,
        type = isSubEntity ? subEntityType : entityType,
        entities = {};
    let exclude = 1;

    if (isSubEntity) {
        if (showSelection.entities && showSelection.entities.length) {
            if (requestType === CLOUD_BILLING_TYPE_REQUEST.INCLUDE && showSelection.requestType === CLOUD_BILLING_TYPE_REQUEST.INCLUDE) {
                entities[entityType] = selectedEntities[entityType].entities.map(entity => entity.id);
                exclude = requestType;
            } else if (requestType === CLOUD_BILLING_TYPE_REQUEST.EXCLUDE && showSelection.requestType === CLOUD_BILLING_TYPE_REQUEST.INCLUDE) {
                const allSelected = selectedEntities[entityType].entities.map(entity => entity.id);

                entities[entityType] = showSelection.entities.map(entity => entity.id).filter(id => !allSelected.find(allId => id === allId));
                exclude = showSelection.requestType;
            } else if (requestType === CLOUD_BILLING_TYPE_REQUEST.INCLUDE && showSelection.requestType === CLOUD_BILLING_TYPE_REQUEST.EXCLUDE) {
                entities[entityType] = selectedEntities[entityType].entities.map(entity => entity.id);
                exclude = requestType;
            } else if (requestType === CLOUD_BILLING_TYPE_REQUEST.EXCLUDE && showSelection.requestType === CLOUD_BILLING_TYPE_REQUEST.EXCLUDE) {
                entities[entityType] = selectedEntities[entityType].entities.map(entity => entity.id).concat(showSelection.entities.map(entity => entity.id));
                exclude = requestType;
            }
        } else {
            entities[entityType] = selectedEntities[entityType].entities.map(entity => entity.id);
            exclude = requestType;
        }
    } else if (showSelection.entities && showSelection.entities.length) {
        entities[entityType] = entities[entityType] ? entities[entityType].concat(showSelection.entities.map(entity => entity.id)) : showSelection.entities.map(entity => entity.id);
        entities[entityType] = [...new Set(entities[entityType])];
        if (!isSubEntity) {
            exclude = showSelection.requestType;
        }
    }


    return {entityType: type, selectedMonth, sort, filters, pagination, entities, requestType: exclude};
};


const CLOUD_BILLING_TOGGLE_ENTITIES = 'CLOUD_BILLING_TOGGLE_ENTITIES';

export const toggleEntities = (storage, entities, entityType) => ({
    type: CLOUD_BILLING_TOGGLE_ENTITIES,
    storage, entities, entityType
});

const _toggleEntities = (entities, stateEntities) => entities.filter(entity => !stateEntities.find(stateEntity => entity.id === stateEntity.id))
    .concat(stateEntities.filter(stateEntity => !entities.find(entity => entity.id === stateEntity.id)));


const CLOUD_BILLING_CHANGE_REQUEST_TYPE = 'CLOUD_BILLING_CHANGE_REQUEST_TYPE';

export const changeRequestType = (storage, entityType, requestType) => ({
    type: CLOUD_BILLING_CHANGE_REQUEST_TYPE,
    storage, entityType, requestType
});


const CLOUD_BILLING_CHANGE_ENTITY_TYPE = 'CLOUD_BILLING_CHANGE_ENTITY_TYPE';

export const changeEntityType = (storage, entityType) => ({
    type: CLOUD_BILLING_CHANGE_ENTITY_TYPE,
    entityType, storage
});


const CLOUD_BILLING_CHANGE_SUBENTITY_TYPE = 'CLOUD_BILLING_CHANGE_SUBENTITY_TYPE';

export const changeSubEntityType = (storage, subEntityType) => ({
    type: CLOUD_BILLING_CHANGE_SUBENTITY_TYPE,
    storage, subEntityType
});

const CLOUD_BILLING_CLEAR_SELECTED_ENTITIES = 'CLOUD_BILLING_CLEAR_SELECTED_ENTITIES';

export const clearSelectedEntities = storage => ({
    type: CLOUD_BILLING_CLEAR_SELECTED_ENTITIES,
    storage
});

const CLOUD_BILLING_SHOW_SELECTION = 'CLOUD_BILLING_SHOW_SELECTION';

export const keepSelection = (storage, entityType) => ({
    type: CLOUD_BILLING_SHOW_SELECTION,
    entityType, storage
});

const CLOUD_BILLING_SHOW_ALL = 'CLOUD_BILLING_SHOW_ALL';

export const showAll = (storage, entityType) => ({
    type: CLOUD_BILLING_SHOW_ALL,
    entityType, storage
});

const CLOUD_BILLING_SEE_IN_BREAKDOWN = 'CLOUD_BILLING_SEE_IN_BREAKDOWN';

export const seeInBreakdown = () => ({
    type: CLOUD_BILLING_SEE_IN_BREAKDOWN
});


const CLOUD_BILLING_SELECT_BOOKMARK = 'CLOUD_BILLING_SELECT_BOOKMARK';

export const selectBookmark = (storage, bookmark) => ({
    type: CLOUD_BILLING_SELECT_BOOKMARK,
    storage, bookmark
});


const _defaultState = () => ({
    explorer: {
        entityType:       CLOUD_BILLING_ENTITY_TYPE.ACCOUNT,
        bookmark:         null,
        selectedEntities: {
            [CLOUD_BILLING_ENTITY_TYPE.PROJECT]: {
                requestType:   CLOUD_BILLING_TYPE_REQUEST.EXCLUDE,
                subEntityType: CLOUD_BILLING_ENTITY_TYPE.ACCOUNT,
                showSelection: {
                    requestType: CLOUD_BILLING_TYPE_REQUEST.EXCLUDE,
                    entities:    []
                },
                entities: []
            },
            [CLOUD_BILLING_ENTITY_TYPE.ACCOUNT]: {
                requestType:   CLOUD_BILLING_TYPE_REQUEST.EXCLUDE,
                subEntityType: CLOUD_BILLING_ENTITY_TYPE.PROJECT,
                showSelection: {
                    requestType: CLOUD_BILLING_TYPE_REQUEST.EXCLUDE,
                    entities:    []
                },
                entities: []
            },
            [CLOUD_BILLING_ENTITY_TYPE.VENDOR]: {
                requestType:   CLOUD_BILLING_TYPE_REQUEST.EXCLUDE,
                subEntityType: CLOUD_BILLING_ENTITY_TYPE.ACCOUNT,
                showSelection: {
                    requestType: CLOUD_BILLING_TYPE_REQUEST.EXCLUDE,
                    entities:    []
                },
                entities: []
            },
            [CLOUD_BILLING_ENTITY_TYPE.SERVICE]: {
                requestType:   CLOUD_BILLING_TYPE_REQUEST.EXCLUDE,
                subEntityType: CLOUD_BILLING_ENTITY_TYPE.ACCOUNT,
                showSelection: {
                    requestType: CLOUD_BILLING_TYPE_REQUEST.EXCLUDE,
                    entities:    []
                },
                entities: []
            },
            [CLOUD_BILLING_ENTITY_TYPE.REGION]: {
                requestType:   CLOUD_BILLING_TYPE_REQUEST.EXCLUDE,
                subEntityType: CLOUD_BILLING_ENTITY_TYPE.ACCOUNT,
                showSelection: {
                    requestType: CLOUD_BILLING_TYPE_REQUEST.EXCLUDE,
                    entities:    []
                },
                entities: []
            }
        }
    },
    breakdown: {
        entityType:       CLOUD_BILLING_ENTITY_TYPE.ACCOUNT,
        bookmark:         null,
        selectedEntities: {
            [CLOUD_BILLING_ENTITY_TYPE.PROJECT]: {
                requestType:   CLOUD_BILLING_TYPE_REQUEST.EXCLUDE,
                subEntityType: CLOUD_BILLING_ENTITY_TYPE.ACCOUNT,
                showSelection: {
                    requestType: CLOUD_BILLING_TYPE_REQUEST.EXCLUDE,
                    entities:    []
                },
                entities: []
            },
            [CLOUD_BILLING_ENTITY_TYPE.ACCOUNT]: {
                requestType:   CLOUD_BILLING_TYPE_REQUEST.EXCLUDE,
                subEntityType: CLOUD_BILLING_ENTITY_TYPE.PROJECT,
                showSelection: {
                    requestType: CLOUD_BILLING_TYPE_REQUEST.EXCLUDE,
                    entities:    []
                },
                entities: []
            },
            [CLOUD_BILLING_ENTITY_TYPE.VENDOR]: {
                requestType:   CLOUD_BILLING_TYPE_REQUEST.EXCLUDE,
                subEntityType: CLOUD_BILLING_ENTITY_TYPE.ACCOUNT,
                showSelection: {
                    requestType: CLOUD_BILLING_TYPE_REQUEST.EXCLUDE,
                    entities:    []
                },
                entities: []
            },
            [CLOUD_BILLING_ENTITY_TYPE.SERVICE]: {
                requestType:   CLOUD_BILLING_TYPE_REQUEST.EXCLUDE,
                subEntityType: CLOUD_BILLING_ENTITY_TYPE.ACCOUNT,
                showSelection: {
                    requestType: CLOUD_BILLING_TYPE_REQUEST.EXCLUDE,
                    entities:    []
                },
                entities: []
            },
            [CLOUD_BILLING_ENTITY_TYPE.REGION]: {
                requestType:   CLOUD_BILLING_TYPE_REQUEST.EXCLUDE,
                subEntityType: CLOUD_BILLING_ENTITY_TYPE.ACCOUNT,
                showSelection: {
                    requestType: CLOUD_BILLING_TYPE_REQUEST.EXCLUDE,
                    entities:    []
                },
                entities: []
            }
        }
    }
});

export const reducer = (state = _defaultState(), action = '') => {
    switch (action.type) {
    case CLOUD_BILLING_TOGGLE_ENTITIES:
        return {
            ...state,
            [action.storage]: {
                ...state[action.storage],
                selectedEntities: {
                    ...state[action.storage].selectedEntities,
                    [action.entityType]: {
                        ...state[action.storage].selectedEntities[action.entityType],
                        entities: _toggleEntities(action.entities, state[action.storage].selectedEntities[action.entityType].entities)
                    }
                }
            }
        };
    case CLOUD_BILLING_CHANGE_REQUEST_TYPE:
        return {
            ...state,
            [action.storage]: {
                ...state[action.storage],
                selectedEntities: {
                    ...state[action.storage].selectedEntities,
                    [action.entityType]: {
                        ...state[action.storage].selectedEntities[action.entityType],
                        requestType: action.requestType,
                        entities:    []
                    }
                }
            }
        };
    case CLOUD_BILLING_CHANGE_ENTITY_TYPE:
        return {
            ...state,
            [action.storage]: {
                ...state[action.storage],
                bookmark:   null,
                entityType: action.entityType
            }
        };
    case CLOUD_BILLING_CHANGE_SUBENTITY_TYPE:
        return {
            ...state,
            [action.storage]: {
                ...state[action.storage],
                bookmark:         null,
                selectedEntities: {
                    ...state[action.storage].selectedEntities,
                    [state[action.storage].entityType]: {
                        ...state[action.storage].selectedEntities[state[action.storage].entityType],
                        subEntityType: action.subEntityType
                    }
                }
            }
        };
    case CLOUD_BILLING_CLEAR_SELECTED_ENTITIES:
        return {
            ...state,
            [action.storage]: {
                ...state[action.storage],
                bookmark:         null,
                selectedEntities: _defaultState()[action.storage].selectedEntities
            }
        };
    case CLOUD_BILLING_SHOW_SELECTION:
        return {
            ...state,
            [action.storage]: {
                ...state[action.storage],
                selectedEntities: {
                    ...state[action.storage].selectedEntities,
                    [state[action.storage].entityType]: {
                        ...state[action.storage].selectedEntities[state[action.storage].entityType],
                        requestType:   CLOUD_BILLING_TYPE_REQUEST.EXCLUDE,
                        entities:      [],
                        showSelection: {
                            entities:    state[action.storage].selectedEntities[state[action.storage].entityType].entities,
                            requestType: state[action.storage].selectedEntities[state[action.storage].entityType].requestType
                        }
                    }
                }
            }
        };
    case CLOUD_BILLING_SHOW_ALL:
        return {
            ...state,
            [action.storage]: {
                ...state[action.storage],
                selectedEntities: {
                    ...state[action.storage].selectedEntities,
                    [state[action.storage].entityType]: {
                        ...state[action.storage].selectedEntities[state[action.storage].entityType],
                        requestType:   state[action.storage].selectedEntities[state[action.storage].entityType].showSelection.requestType,
                        entities:      state[action.storage].selectedEntities[state[action.storage].entityType].showSelection.entities,
                        showSelection: {
                            requestType: CLOUD_BILLING_TYPE_REQUEST.EXCLUDE,
                            entities:    []
                        }
                    }
                }
            }
        };
    case CLOUD_BILLING_SEE_IN_BREAKDOWN:
        return {
            ...state,
            breakdown: {
                entityType:       state.explorer.entityType,
                selectedEntities: {
                    ...state.breakdown.selectedEntities,
                    [state.explorer.entityType]: state.explorer.selectedEntities[state.explorer.entityType]
                }
            }
        };
    case CLOUD_BILLING_SELECT_BOOKMARK:
        return {
            ...state,
            [action.storage]: {
                ...state[action.storage],
                bookmark: action.bookmark
            }
        };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/cloudBillingEntities.js